import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-[11px] font-mono font-bold uppercase tracking-[0.22em] text-blue-700 bg-blue-50 px-3.5 py-1.5 rounded-full border border-blue-200">
    <span className="w-1.5 h-1.5 rounded-full bg-blue-600 live-dot" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "left" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl mb-14 lg:mb-20`}>
    <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 fluid-h2 font-bold tracking-tight text-slate-900 leading-[1.12]">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base text-slate-500 leading-relaxed">{sub}</p>
      </Reveal>
    )}
  </div>
);
